import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Button,
  Slider,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  FormControl,
  ButtonGroup,
  Tooltip,
  DialogContentText,
  Backdrop,
  CircularProgress,
  Switch,
} from '@mui/material';
import PhotoIcon from '@mui/icons-material/Photo';
import { Monitor, ExpandMore, Info, WbSunny } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { analyzeLocation } from 'src/utils/analyze-location';
import { useTranslation } from 'react-i18next';
import photoPlch from '../../../images/photo-placeholder.png';
import playlistPch from '../../../images/playlist-placeholder.png';
import schedulerPch from '../../../images/scheduler-placeholder.png';
import SelectPlaylistModal from 'src/components/selectfilesmodal/SelectPlaylistModal';
import SelectSchedulerModal from 'src/components/selectfilesmodal/SelectSchedulerModal';
import SelectFilesModalScreen from './SelectFilesModalScreen';
import { PlaceholderPicker } from 'src/components/placeholder/PlaceholderPicker';
import { BlockPicker, CirclePicker, TwitterPicker } from 'react-color';
import { FaTwitch } from 'react-icons/fa';
import { resolveSrc } from 'src/api/endpoints';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { updateScreenv2 } from 'src/redux/actions/Screen';
import WebviewWarningDialog from 'src/components/webviewwarning/WebviewWarningDialog';
import {
  getWebviewContentIssues,
  isLegacyAndroid,
} from 'src/utils/webviewCompat';

export function UpdateScreenModal({ open, onClose, screen }) {
  const locationRef = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [openSelectFilesModal, setOpenSelectFilesModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState({
    type: '',
    name: '',
    id: '',
    data: null,
  });
  const [pendingSelection, setPendingSelection] = useState(null);
  const [openPlaylistModal, setOpenPlaylistModal] = useState(false);
  const [openSelectSchedulerModal, setOpenSelectSchedulerModal] =
    useState(false);
  const [openConfirmContinueDialog, setOpenConfirmContinueDialog] =
    useState(false);
  const [openLoadingBackdrop, setOpenLoadingBackdrop] = useState(false);
  const [cType, setCtype] = useState('def');
  const [pairingDetails, setPairingDetails] = useState({
    deviceName: '',
    screenCode: '',
    orientation: 'landscape',
    locationDetails: {
      fullLocation: false,
      mostDetailedLevel: '',
      lat: '',
      lng: '',
      formatted_address: '',
      short_address: '',
    },
    playlist: null,
    background: {
      type: '',
      value: '',
    },
    brightness: 100,
    volume: 0,
    syncPlay: false,
    preloadAssetPlaylist: false,
    showOfflineIndicator: false,
    showDownloadStatus: true,
    playBackControl: false,
    mute: false,
    blackScreen: false,
    placeholderLandscape: '',
    placeholderPortrait: '',
    placeholderResize: 'cover',
  });

  useEffect(() => {
    if (screen) {
      setPairingDetails({
        ...pairingDetails,
        ...screen,
        orientation: screen.oriantation,
        background: screen.backgroundType,
        blackScreen:
          screen?.playlist?.playlistName == 'scheduler-placeholder'
            ? true
            : false,
      });

      if (screen?.scheduler?.name) {
        setSelectedFile({
          type: 'scheduler',
          name: screen?.scheduler?.name,
          id: screen?.scheduler?._id,
        });
      }

      const playlist = screen?.playlist;
      const playlistContent = playlist?.content?.[0];
      if (playlistContent?.purpose === 'asset') {
        const asset = playlistContent.content;
        if (asset?._id) {
          setSelectedFile({
            type: 'object',
            name: playlist.playlistName,
            id: asset._id,
            data: asset,
          });
        } else {
          setSelectedFile({
            type: '',
            name: '',
            id: '',
            data: null,
          });
        }
      } else if (playlist?._id) {
        setSelectedFile({
          type: 'playlist',
          name: playlist.playlistName,
          id: playlist._id,
        });
      } else {
        setSelectedFile({
          type: '',
          name: '',
          id: '',
          data: null,
        });
      }
    }
  }, [screen]);

  const screenWidth = Number(screen?.device_details?.width);
  const screenHeight = Number(screen?.device_details?.height);
  const screenIsPortrait =
    screenWidth > 0 && screenHeight > 0
      ? screenHeight > screenWidth
      : screen?.oriantation === 'portrait';

  const onGetLatLonByLocatioChange = () => {
    const placeObject = locationRef.current.getPlace();
    console.log(placeObject);
    // const lat = placeObject.geometry.location.lat();
    // const lng = placeObject.geometry.location.lng();
    // setLocation(placeObject?.name);
    setPairingDetails({
      ...pairingDetails,
      locationDetails: analyzeLocation(t, placeObject),
    });
    // setLat(lat);
    // setLng(lng);
  };

  const GetFilePreview = ({ type, contentObject }) => {
    console.log(type, contentObject);
    return type === 'split_screen' ? (
      <img
        src={contentObject.widget?.widgetIcon}
        style={{
          width: '150px',
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          objectFit: 'contain',
        }}
      />
    ) : contentObject?.widget?.widgetCat === 'website' ||
      contentObject?.widget?.widgetCat === 'postermywall' ? (
      <img
        src={contentObject.widget?.widgetIcon}
        style={{
          width: '150px',
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          objectFit: 'contain',
        }}
      />
    ) : contentObject?.widget?.widgetCat === 'yt_playlist' ? (
      <img
        src={'/images/yt_app.png'}
        style={{
          width: '150px',
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          objectFit: 'contain',
        }}
      />
    ) : contentObject?.widget?.widgetCat === 'twitch' ? (
      // /twitchtv?chat=true&channel=lablabai
      <FaTwitch size={'32px'} style={{ marginTop: '10px', color: '#9147ff' }} />
    ) : (
      <>
        {type === 'image' && (
          <img
            src={resolveSrc(contentObject.url)}
            style={{
              height: '100px',
              width: '150px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
        )}
        {type === 'video' && (
          <video
            src={resolveSrc(contentObject.url)}
            style={{
              height: '100px',
              width: '150px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          ></video>
        )}
        {contentObject.embed === 'embed' && (
          <embed
            src={contentObject.url}
            style={{
              height: '100px',
              width: '150px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          ></embed>
        )}
        {type === 'widget' && (
          <img
            src={contentObject.widget?.widgetIcon}
            style={{
              width: '150px',
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              objectFit: 'contain',
            }}
          />
        )}
      </>
    );
  };

  const resetModal = () => {
    setCtype('def');
    setSelectedFile({ type: '', name: '', id: '', data: null });
    setPairingDetails({
      deviceName: '',
      screenCode: '',
      orientation: 'landscape',
      locationDetails: {
        fullLocation: false,
        mostDetailedLevel: '',
        lat: '',
        lng: '',
        formatted_address: '',
        short_address: '',
      },
      playlist: null,
      background: {
        type: '',
        value: '',
      },
      brightness: 100,
      volume: 0,
      syncPlay: false,
      preloadAssetPlaylist: false,
      showOfflineIndicator: false,
      showDownloadStatus: true,
      playBackControl: false,
      mute: false,
      blackScreen: false,
      placeholderLandscape: '',
      placeholderPortrait: '',
    placeholderResize: 'cover',
    });
  };

  useEffect(() => {
    if (cType == 'object') {
      setOpenSelectFilesModal(true);
      setPairingDetails({ ...pairingDetails, blackScreen: false });
    } else if (cType == 'playlist') {
      setOpenPlaylistModal(true);
      setPairingDetails({ ...pairingDetails, blackScreen: false });
    } else if (cType == 'scheduler') {
      setOpenSelectSchedulerModal(true);
    } else if (cType == 'blackScreen') {
      setPairingDetails({ ...pairingDetails, blackScreen: true });
    }
  }, [cType]);

  // Asks for confirmation before attaching WebView-based content to Android <= 9 devices.
  const selectWithWebviewGuard = (selection, target) => {
    const issues = isLegacyAndroid(screen?.device_details?.os_version)
      ? getWebviewContentIssues(target)
      : [];
    if (issues.length > 0) {
      setPendingSelection({ selection, issues });
    } else {
      setSelectedFile(selection);
    }
  };

  const onUpdateScreen = (e) => {
    e.preventDefault();
    if (!selectedFile.id && cType != 'blackScreen') {
      return toast.error(t('views.redesignScreens.contentRequired'));
    } else {
      if (pairingDetails.locationDetails.fullLocation) {
        letsUpdate();
      } else {
        setOpenConfirmContinueDialog(true);
      }
    }
  };

  const letsUpdate = async () => {
    const reqOb = {
      ...pairingDetails,
      assetId: selectedFile.id,
      assetType: selectedFile.type,
      brightness: `${pairingDetails.brightness}`,
      volume: `${pairingDetails.volume}`,
    };

    if (screen?._id) {
      reqOb.id = screen?._id;
    } else {
      reqOb.screenCode = pairingDetails.screenCode;
    }

    // console.log(reqOb)
    setOpenLoadingBackdrop(true);
    setOpenConfirmContinueDialog(false);
    resetModal();
    onClose();
    const newScreen = await dispatch(updateScreenv2(reqOb));
    console.log(newScreen);
    if (newScreen?.mac) {
      setOpenLoadingBackdrop(false);
      // dispatch(updateScreenv2({

      // }))
    } else {
      setOpenLoadingBackdrop(false);
    }
  };
  const generateRandomScreenName = () => {
    const letters = 'abcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < 5; i++) {
      const randomIndex = Math.floor(Math.random() * letters.length);
      result += letters[randomIndex];
    }
    return `Screen-${result}`;
  };

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={openLoadingBackdrop}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Dialog
        open={openConfirmContinueDialog}
        onClose={() => setOpenConfirmContinueDialog(false)}
      >
        <DialogTitle
          sx={{
            mt: 2,
          }}
          textAlign='center'
        >
          {t('views.redesignScreens.continueAreYouSure')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText textAlign='center'>
            {t('views.redesignScreens.locationNotAccurate')}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Button
            variant='outlined'
            size={'small'}
            color='error'
            onClick={() => setOpenConfirmContinueDialog(false)}
          >
            {t('views.redesignScreens.noCancel')}
          </Button>
          <Button variant='outlined' size={'small'} onClick={letsUpdate}>
            {t('views.redesignScreens.yesContinue')}
          </Button>
        </DialogActions>
      </Dialog>
      <SelectPlaylistModal
        open={openPlaylistModal}
        onClose={() => setOpenPlaylistModal(false)}
        onSelectPlaylist={(p) => {
          selectWithWebviewGuard(
            { type: 'playlist', name: p.playlistName, id: p._id },
            p,
          );
        }}
      />
      <WebviewWarningDialog
        open={!!pendingSelection}
        issues={pendingSelection?.issues}
        onCancel={() => setPendingSelection(null)}
        onConfirm={() => {
          setSelectedFile(pendingSelection.selection);
          setPendingSelection(null);
        }}
      />
      <SelectSchedulerModal
        open={openSelectSchedulerModal}
        onClose={() => setOpenSelectSchedulerModal(false)}
        onSelectScheduler={(sch) => {
          setSelectedFile({ type: 'scheduler', name: sch.name, id: sch._id });
        }}
      />
      <SelectFilesModalScreen
        open={openSelectFilesModal}
        setOpenSelectFiles={setOpenSelectFilesModal}
        screenOsVersion={screen?.device_details?.os_version}
        onSaveFiles={() => {}}
        onSaveFilesForQuickP={(selectedFiles) => {
          if (selectedFiles) {
            console.log(selectedFiles);
            // const selected = content.find((asset) => asset.id === selectedFiles[0]);
            selectWithWebviewGuard(
              {
                type: 'object',
                name: selectedFiles.name,
                id: selectedFiles.id,
                data: selectedFiles,
              },
              selectedFiles,
            );
            setOpenSelectFilesModal(false);
          }
        }}
      />
      <Dialog
        open={open}
        onClose={() => {
          resetModal();
          onClose();
        }}
        maxWidth='sm'
        fullWidth
        sx={{
          p: 2,
        }}
      >
        <DialogTitle sx={{ pb: 1, pm: 2 }}>
          <Typography variant='h6' textAlign='center'>
            {screen
              ? t('views.redesignScreens.updateScreen')
              : t('views.screenTable.addScreen')}
          </Typography>
        </DialogTitle>
        <form onSubmit={onUpdateScreen}>
          <DialogContent
            sx={{
              px: 3,
              py: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
            }}
          >
            <TextField
              fullWidth
              required
              label={t('views.redesignScreens.pairingCodeRequired')}
              value={pairingDetails.screenCode}
              onChange={(e) =>
                setPairingDetails({
                  ...pairingDetails,
                  screenCode: e.target.value,
                })
              }
              disabled={screen ? true : false}
              variant='standard'
              sx={{ mb: 3 }}
              inputProps={{
                maxLength: 4,
                pattern: '^[0-9]{4}$',
              }}
            />

            <TextField
              fullWidth
              label={t('views.redesignScreens.deviceNameRequired')}
              value={pairingDetails.deviceName}
              onChange={(e) =>
                setPairingDetails({
                  ...pairingDetails,
                  deviceName: e.target.value,
                })
              }
              variant='standard'
              defaultValue={!screen && generateRandomScreenName()}
              required
              sx={{ mb: 3 }}
              inputProps={{
                maxLength: 40,
                minLength: 1,
              }}
              helperText={`${pairingDetails.deviceName.length}/40`}
            />

            {/* Pairing code */}

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                flexWrap: 'wrap',
              }}
            >
              <Typography>{t('views.redesignScreens.oriantation')}</Typography>
              {/* <ButtonGroup variant="text" aria-label="Basic button group"> */}
              <Button
                variant={
                  pairingDetails.orientation == 'landscape' ? 'contained' : ''
                }
                onClick={() => {
                  setPairingDetails({
                    ...pairingDetails,
                    orientation: 'landscape',
                  });
                }}
              >
                <PhotoIcon />
              </Button>
              <Button
                variant={pairingDetails.orientation == '90' ? 'contained' : ''}
                onClick={() => {
                  setPairingDetails({ ...pairingDetails, orientation: '90' });
                }}
              >
                <PhotoIcon
                  sx={{
                    transform: 'rotate(90deg)',
                  }}
                />
              </Button>
              <Button
                variant={pairingDetails.orientation == '180' ? 'contained' : ''}
                onClick={() => {
                  setPairingDetails({ ...pairingDetails, orientation: '180' });
                }}
              >
                <PhotoIcon
                  sx={{
                    transform: 'rotate(180deg)',
                  }}
                />
              </Button>
              <Button
                variant={pairingDetails.orientation == '270' ? 'contained' : ''}
                onClick={() => {
                  setPairingDetails({ ...pairingDetails, orientation: '270' });
                }}
              >
                <PhotoIcon
                  sx={{
                    transform: 'rotate(270deg)',
                  }}
                />
              </Button>
              {/* </ButtonGroup> */}
            </Box>

            {/* Location */}
            <Box
              sx={{
                margin: '10px 0',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  zIndex: '1000000000000000',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  marginTop: '20px',
                }}
              >
                <Typography variant='caption' color='warning.main'>
                  {!pairingDetails.locationDetails?.fullLocation
                    ? t('views.redesignScreens.enterLocation')
                    : null}
                </Typography>
                <Box
                  sx={{ display: 'flex', width: '100%', alignItems: 'center' }}
                >
                  <Box sx={{ width: '100%', marginTop: '10px' }}>
                    <Autocomplete
                      onLoad={(autocomplete) =>
                        (locationRef.current = autocomplete)
                      }
                      onPlaceChanged={onGetLatLonByLocatioChange}
                    >
                      <TextField
                        type={'text'}
                        label={t('views.redesignScreens.location')}
                        variant={'standard'}
                        value={
                          pairingDetails?.locationDetails?.formatted_address
                        }
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            locationDetails: {
                              ...pairingDetails?.locationDetails,
                              formatted_address: e.target.value,
                            },
                          })
                        }
                        fullWidth
                        required
                      />
                    </Autocomplete>
                  </Box>
                  {!pairingDetails?.locationDetails?.fullLocation ? (
                    <Tooltip
                      title={t('views.redesignScreens.enterLocationTip')}
                      placement='left'
                    >
                      <InfoIcon sx={{ color: '#FFA726' }} />
                    </Tooltip>
                  ) : null}
                </Box>
              </Box>
              {pairingDetails?.locationDetails ? (
                <Typography
                  variant='caption'
                  color={pairingDetails?.locationDetails?.labelColor}
                >
                  {pairingDetails?.locationDetails?.labelMsg}
                </Typography>
              ) : null}
              {screen && (
                <Box sx={{ mt: 2 }}>
                  <PlaceholderPicker
                    only={screenIsPortrait ? 'portrait' : 'landscape'}
                    value={{
                      landscape: pairingDetails.placeholderLandscape,
                      portrait: pairingDetails.placeholderPortrait,
                      resize: pairingDetails.placeholderResize,
                    }}
                    onChange={(v) =>
                      setPairingDetails((prev) => ({
                        ...prev,
                        placeholderLandscape: v.landscape,
                        placeholderPortrait: v.portrait,
                        placeholderResize: v.resize,
                      }))
                    }
                  />
                </Box>
              )}
            </Box>

            {/* Type */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '20px',
                mt: 4,
                mb: 2,
                flexWrap: 'wrap',
              }}
            >
              {selectedFile.data?.type ? (
                <GetFilePreview
                  type={selectedFile.data?.type}
                  contentObject={selectedFile.data}
                />
              ) : (
                <>
                  {selectedFile?.type == 'playlist' ? (
                    <img
                      src={playlistPch}
                      style={{
                        height: '100px',
                        width: '150px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  ) : selectedFile?.type == 'scheduler' ? (
                    <img
                      src={schedulerPch}
                      style={{
                        height: '100px',
                        width: '150px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  ) : (
                    <img
                      src={photoPlch}
                      style={{
                        height: '100px',
                        width: '150px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  )}
                </>
              )}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '10px',
                }}
              >
                {selectedFile?.name && (
                  <Typography variant='subtitle1' mt={3}>
                    {selectedFile?.name.length > 30
                      ? `${selectedFile?.name.slice(0, 30)}...`
                      : selectedFile?.name}
                  </Typography>
                )}
                {!selectedFile?.name ? (
                  <>
                    <FormControl sx={{ minWidth: 150 }} size='small'>
                      <Select
                        value={cType}
                        onChange={(e) => {
                          if (e.target.value == 'blackScreen') {
                            setPairingDetails({
                              ...pairingDetails,
                              blackScreen: true,
                            });
                          } else {
                            setPairingDetails({
                              ...pairingDetails,
                              blackScreen: false,
                            });
                          }
                          setCtype(e.target.value);
                        }}
                      >
                        <MenuItem value='def'>
                          <em>{t('views.scheduler.contentType')}</em>
                        </MenuItem>
                        <MenuItem value={'object'}>
                          {t('views.scheduler.object')}
                        </MenuItem>
                        <MenuItem value={'playlist'}>
                          {t('views.scheduler.playlist')}
                        </MenuItem>
                        {screen?.scheduler && (
                          <MenuItem value={'blackScreen'}>
                            Black screen
                          </MenuItem>
                        )}
                        {/* <MenuItem value={'scheduler'}>{t("layout.sidebar.scheduler")}</MenuItem> */}
                      </Select>
                    </FormControl>
                    {cType !== 'def' && cType != 'blackScreen' && (
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={() => {
                          if (cType == 'object') {
                            setOpenSelectFilesModal(true);
                            setPairingDetails({
                              ...pairingDetails,
                              blackScreen: false,
                            });
                          } else if (cType == 'playlist') {
                            setOpenPlaylistModal(true);
                            setPairingDetails({
                              ...pairingDetails,
                              blackScreen: false,
                            });
                          } else if (cType == 'scheduler') {
                            setOpenSelectSchedulerModal(true);
                          } else if (cType == 'blackScreen') {
                            setPairingDetails({
                              ...pairingDetails,
                              blackScreen: true,
                            });
                          }
                        }}
                      >
                        {t('views.redesignScreens.selectFile')}
                      </Button>
                    )}
                  </>
                ) : (
                  <Button
                    variant='outlined'
                    size='small'
                    endIcon={<EditIcon />}
                    onClick={() =>
                      setSelectedFile({
                        type: '',
                        name: '',
                        id: '',
                        data: null,
                      })
                    }
                  >
                    {t('views.redesignScreens.chooseAnotherContent')}
                  </Button>
                )}
              </Box>
            </Box>
            {cType == 'blackScreen' && (
              <Typography
                variant='caption'
                color='warning.main'
                textAlign={'center'}
              >
                {t('views.redesignScreens.blackScreenInfo')}
              </Typography>
            )}
            {/* { screen?.scheduler && (
                    <FormControlLabel control={<Switch checked={pairingDetails.blackScreen} onChange={(e) => setPairingDetails({...pairingDetails, blackScreen: e.target.checked})} />} label={t("views.redesignScreens.label")} />
                )} */}

            {/* Advanced Section */}
            <Accordion
              sx={{
                // display: "none",
                bgcolor: 'transparent',
                backgroundImage: 'none',
                boxShadow: 'none',
                // '&:before': { display: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                  px: 0,
                  minHeight: 48,
                  '& .MuiAccordionSummary-content': { my: 1 },
                }}
              >
                <Typography>{t('views.redesignScreens.advanced')}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, pt: 2 }}>
                {/* Background Type */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: '20px',
                    flexDirection: 'column',
                    mb: 3,
                  }}
                >
                  <Typography>Background</Typography>
                  <CirclePicker
                    width='100%'
                    triangle='hide'
                    colors={[
                      '#D9E3F0',
                      '#F47373',
                      '#697689',
                      '#37D67A',
                      '#2CCCE4',
                      '#555555',
                      '#dce775',
                      '#ff8a65',
                      '#ba68c8',
                    ]}
                    color={pairingDetails.background.value}
                    onChange={(c) =>
                      setPairingDetails({
                        ...pairingDetails,
                        background: { type: 'color', value: c.hex },
                      })
                    }
                  />
                </Box>

                {/* Brightness Slider */}
                <Box sx={{ mb: 3, px: 2 }}>
                  <Typography
                    variant='body2'
                    sx={{ mb: 1, textAlign: 'center' }}
                  >
                    {t('views.redesignScreens.brightness')}
                  </Typography>
                  <Slider
                    value={pairingDetails.brightness}
                    onChange={(v) =>
                      setPairingDetails({
                        ...pairingDetails,
                        brightness: v.target.value,
                      })
                    }
                    min={0}
                    max={100}
                    valueLabelDisplay='auto'
                    marks={[
                      { value: 0, label: '0%' },
                      { value: 100, label: '100%' },
                    ]}
                  />
                </Box>

                <Box sx={{ mb: 3, px: 2 }}>
                  <Typography
                    variant='body2'
                    sx={{ mb: 1, textAlign: 'center' }}
                  >
                    {t('views.redesignScreens.volume')}
                  </Typography>
                  <Slider
                    value={pairingDetails.volume}
                    onChange={(v) =>
                      setPairingDetails({
                        ...pairingDetails,
                        volume: v.target.value,
                      })
                    }
                    min={0}
                    max={100}
                    valueLabelDisplay='auto'
                    marks={[
                      { value: 0, label: '0%' },
                      { value: 100, label: '100%' },
                    ]}
                  />
                </Box>

                {/* Options */}
                <Box sx={{ mb: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!pairingDetails.showDownloadStatus}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            showDownloadStatus: e.target.checked,
                          })
                        }
                      />
                    }
                    label='Download progress bar visibility'
                  />
                </Box>

                {/* Placeholder (add mode only; edit mode shows it below location) */}
                {!screen && (
                <Box sx={{ mb: 3 }}>
                  <PlaceholderPicker
                    value={{
                      landscape: pairingDetails.placeholderLandscape,
                      portrait: pairingDetails.placeholderPortrait,
                      resize: pairingDetails.placeholderResize,
                    }}
                    onChange={(v) =>
                      setPairingDetails((prev) => ({
                        ...prev,
                        placeholderLandscape: v.landscape,
                        placeholderPortrait: v.portrait,
                        placeholderResize: v.resize,
                      }))
                    }
                  />
                </Box>
                )}

                {/* Checkboxes */}
                <Box sx={{ display: 'none' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pairingDetails.syncPlay}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            syncPlay: e.target.checked,
                          })
                        }
                      />
                    }
                    label={t('views.redesignScreens.syncPlay')}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pairingDetails.preloadAssetPlaylist}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            preloadAssetPlaylist: e.target.checked,
                          })
                        }
                      />
                    }
                    label={t('views.redesignScreens.preloadAssets')}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pairingDetails.showOfflineIndicator}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            showOfflineIndicator: e.target.checked,
                          })
                        }
                      />
                    }
                    label={t('views.redesignScreens.showOfflineIndicator')}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pairingDetails.playBackControl}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            playBackControl: e.target.checked,
                          })
                        }
                      />
                    }
                    label={t('views.redesignScreens.playbackControl')}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pairingDetails.mute}
                        onChange={(e) =>
                          setPairingDetails({
                            ...pairingDetails,
                            mute: e.target.checked,
                          })
                        }
                      />
                    }
                    label={t('views.redesignScreens.mute')}
                  />
                </Box>
              </AccordionDetails>
            </Accordion>
            {/* Device name */}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant='contained'
              color='error'
              onClick={() => {
                resetModal();
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button variant='contained' type='submit'>
              {screen ? 'Update' : 'Add'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
